import React, { useState, useEffect, memo, useReducer, useImperativeHandle } from 'react';
import { Colors } from '../../constants';

const QualificationQuestion = memo((props) =>{
  const [ question, setQuestion ] = useState(null);
  const [ uid, setUid ] = useState(null);
  const [ color, setColor ] = useState('');
  const [ locationSearch, setLocationSearch ] = useState(null);
  const [ elements, setElements ] = useState([]);
  const [ isParentQuestion, setIsParentQuestion ] = useState(false); // if true it means that the question has previous question
  const {
    backButtonRef,
    userTeamPathId,
    typeUser,
    answerOptionRef,
    handleClickedOptionQualification
  } = props;

  useEffect(() => {
    setQuestion(props.question);
    setUid(props.uid);
    setLocationSearch(props.locationSearch);
    setColor(props.color);
  }, [props]);

  useEffect(() => {
    if (question && locationSearch) {
      let searchParams = new URLSearchParams(locationSearch);
      let questions = searchParams.get('q');
      if (questions) {
        questions = questions?.split(",");
        let index = -1;
        if (questions.includes(question['question_id'])) {
          index = questions.findIndex(x => x === question['question_id']);
          questions.splice(index, 1);
        }

        let answers = searchParams.get('a')?.split(",");
        if (index !== -1) {
          answers.splice(index, 1);
        }

        searchParams.set('q', questions.join(","));
        searchParams.set('a', answers.join(","));

        setLocationSearch(`?${searchParams.toString() || ''}`);
      }
    }
  },[locationSearch, question]);

  useEffect(() => {
    if(question){
      if(question['options'] && question['options'].length > 0){
        let elements = [];

        question['options'].forEach((option, index) => {
          elements.push(
            <QuestionOption
              uid={uid}
              key={index}
              color={color}
              option={option}
              searchQuery={locationSearch}
              optionClicked={optionClicked} />
          )
        });

        setElements(elements);
      }

      if(question['parent_question_id']){
        setIsParentQuestion(true);
      }
    }
  },
  // eslint-disable-next-line
  [question]);

  // useEffect(() => {
  //   goTo(answerOptionRef.current)
  // },
  // // eslint-disable-next-line
  // [width]);

  const backLink = () => {
    if(isParentQuestion) return `/event/${uid}/${question['parent_question_id']}${locationSearch}`;
    else {
      if(typeUser){
        if(typeUser === 'user') return `/${userTeamPathId}`
        else if(typeUser === 'team') return `/t/${userTeamPathId}`
      }
    }
  };

  useImperativeHandle(backButtonRef, () => ({
    backOnClick(){
      handleBackOnClick(backLink())
    }
  }));

  const handleBackOnClick = (link = false) => {
    if(link){
      window.location.href = link;
    }
  };

  const optionClicked = (link = null, optionHashId = null) => {
    if (link) {
      const { innerWidth: width } = window;
      if (optionHashId) {
        // add url params
        let searchParams = new URLSearchParams(window.location.search);
        let questions = searchParams.get('q');

        questions = questions?.split(",") || [];
        let answers = searchParams.get('a');
        answers = answers?.split(",") || [];
        questions.push(question['question_id']);

        answers.push(optionHashId);
        questions = questions?.join(",");
        answers = answers?.join(",");
        let url = new URL(`${window.location.origin}${link}/`);
        url.searchParams.set('q', questions);
        url.searchParams.set('a', answers);
        link = `${url.origin}${url.pathname}/${url.search}`;
      }

      if (width > 858) {
        goTo(link);
      }
      else {
        handleClickedOptionQualification(link);
      }

    }
  };

  const goTo = (link) =>{
    if (link) {
      window.location = link;
    }
  };

  useImperativeHandle (answerOptionRef, () => ({
    goTo(link) {
      goTo(link);
    }
  }));

  if(!question) return null;

  return(
    <>
      <div className="header">
        {question['title']}
      </div>
      <div className="content-wrap-overflow">
        <div className="qualification-questions" id="qualification-questions">
            <ul className="list">
              { elements }
            </ul>
        </div>

        {/* {(isParentQuestion || locationSearch) && (width > 858) &&
            <button
              onClick={() => handleBackOnClick(backLink())}
              className="back-button"
              style={{ color: color }} >
              {t('Go Back')}
            </button>
        } */}
      </div>
    </>
  );
});


const QuestionOption = (props) => {
  const initialState = {
    color: Colors.black,
    fontColor:'#394f5a',
    bgColor:'#fdfdfd'
  };

  const {
    color,
    option,
    uid,
    searchQuery,
    optionClicked
  } = props;


  const reducer = (state, action) => {
    switch ( action.type ){
      case 'mouse_over':
        return {
          color: color,
          fontColor: color
        }
      case 'mouse_out':
        return {
          color: Colors.black,
          fontColor: Colors.black,
        }
      default:
        throw new Error();
    }
  };
  const [ state, dispatch ] = useReducer(reducer, initialState);

  const RedirectOption = () => {
    return(
      <button
        type="button"
        onClick={() => optionClicked(option['action'])}
        onTouchStart={() => optionClicked(option['action'])}
        className="question-option"
        style = {{ color: state.color, borderColor: state.color }}
        onMouseEnter={ () => dispatch({type: 'mouse_over'}) }
        onMouseLeave={ () => dispatch({type: 'mouse_out'}) } >
          {option['name']}
      </button>
    )
  };

  const BookingPage = () => {
    return(
      <button
        type="button"
        onClick={() => optionClicked(`/event/${uid}/${option['hash_id']}${searchQuery}`, `${option['hash_id']}`)}
        onTouchStart={() => optionClicked(`/event/${uid}/${option['hash_id']}${searchQuery}`, `${option['hash_id']}`)}
        className="question-option"
        style = {{ color: state.color, borderColor: state.color }}
        onMouseEnter={ () => dispatch({type: 'mouse_over'}) }
        onMouseLeave={ () => dispatch({type: 'mouse_out'}) } >
          {option['name']}
      </button>
    );
  };

  const Question = () => {
    return(
      <button
        type="button"
        onClick={() => optionClicked(`/event/${uid}/${option['hash_id']}${searchQuery}`, `${option['hash_id']}`)}
        onTouchStart={() => optionClicked(`/event/${uid}/${option['hash_id']}${searchQuery}`, `${option['hash_id']}`)}
        className="question-option"
        style = {{ color: state.color, borderColor: state.color }}
        onMouseEnter={ () => dispatch({type: 'mouse_over'}) }
        onMouseLeave={ () => dispatch({type: 'mouse_out'}) } >
          {option['name']}
      </button>
    )
  };

  const optionType = () => {
    switch (option['action_type']) {
      case 'redirect': return <RedirectOption />;
      case 'booking_page': return <BookingPage />;
      case 'question': return <Question />;
      default: return null;
    }
  };

  if(!option) return null;

  return(
    <>
      { optionType() }
    </>
  );
}

export default QualificationQuestion;
